// extracted by mini-css-extract-plugin
export default {"changePassword":"ChangePassword_changePassword__PqOmP"};